import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66e24e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item item-project" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-right":"10px"}
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_9 = { class: "meta" }
const _hoisted_10 = { class: "meta-title" }
const _hoisted_11 = { style: {"margin-left":"5px"} }
const _hoisted_12 = {
  key: 0,
  class: "time time-end"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已停止", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "time"
}
const _hoisted_16 = { class: "desc" }

import { ref, reactive, computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemProject',
  props: {
  data: {
    type: Object,
    required: false,
  },
},
  setup(__props) {

const props = __props
const rate = ref(0)
const prjUrl = computed(() => {
  return '/project/' + state.id
})
const deadlineInfo = computed(()=>{
  const str = (state.deadline ?? '').split(' ')[0];
  const date = new Date(str).valueOf();
  console.log('date',date)
  const now = new Date().valueOf();
  if( date < now ){
    return { end: true }
  }else{
    return { label: str }
  }
})
const state = reactive({ ...(props.data || {}) })
rate.value = Number(state.userStarLevel) || 0

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: prjUrl.value,
      class: "poster"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: state.coverImage
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_router_link, { to: prjUrl.value }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(state.title), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("em", null, [
              (state.intendAmount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "预筹" + _toDisplayString(state.intendAmount) + "万", 1))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createTextVNode(_toDisplayString(state.pvCount) + "人浏览", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_rate, {
                modelValue: rate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rate).value = $event)),
                disabled: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(state.province) + _toDisplayString(state.city), 1),
              _createVNode(_component_svg_icon, { icon: "icon_gis" })
            ]),
            _createElementVNode("div", null, [
              (deadlineInfo.value.end)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", null, "截止：" + _toDisplayString(deadlineInfo.value.label), 1)
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, _toDisplayString(state.content), 1)
      ])
    ])
  ]))
}
}

})